export const AutocompleteSx = {
  hideClearButton: {
    '& div .MuiAutocomplete-popupIndicator': {
      display: 'none !important',
    },
  },
};
